import axios from 'axios';

const client = axios.create({
  // baseURL: 'http://localhost:8081/'

  // Dev
  baseURL: 'https://kps-executive-api-wckqd7o3eq-uw.a.run.app/' 

  // UAT_NEW_Innive_URL
  // baseURL: 'https://uat.kps.executivedashboard.innive.com/'


});

export default client;
